import { PlanningGroupsItem } from '@/types/service-response'
import store from '@/store'

export class PlanningGroupsList {
  private constructor (
    readonly id: number,
    readonly planningGroupName: string
  ) {}

  public static createListFromResponse (data: Array<PlanningGroupsItem>): Array<PlanningGroupsList> {
    const list: Array<PlanningGroupsItem> = data.filter((item: PlanningGroupsItem) => item.Sprache === store.state.selectedUiLanguage!.syzId)

    return list.map((item: any) => {
      return new PlanningGroupsList(
        item.PlanungsgruppeID,
        item.PlanungsgruppeName,
      )
    })
  }
}
